import { render, staticRenderFns } from "./ViewRequest.vue?vue&type=template&id=50c3dd6d&scoped=true&"
import script from "./ViewRequest.vue?vue&type=script&lang=js&"
export * from "./ViewRequest.vue?vue&type=script&lang=js&"
import style0 from "./ViewRequest.vue?vue&type=style&index=0&id=50c3dd6d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50c3dd6d",
  null
  
)

export default component.exports